import { loader } from 'graphql.macro'

export default function resourceImport ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./resourceImport.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { id: variables.id })
}
